/* eslint-disable camelcase */
import React from 'react';

import Card from '../Card';
import { useChatContext } from '../../context';

import { ChatMessage } from './components/ChatMessage/components/ChatMessage';
import { useChatMessages } from './hooks/useChatMessages';

export function ChatMessages() {
  const { chatListRef } = useChatMessages();
  const { history } = useChatContext();

  return (
    <Card
      className="p-5 max-w-3xl w-full flex flex-col mb-8 overflow-y-auto scrollbar"
      ref={chatListRef}
      data-testid="chat-messages"
    >
      <div className="flex-1">
        {history.length === 0 ? (
          <div
            data-testid="empty-history-message"
            className="text-center opacity-50"
          >
            Please provide the information requested.
          </div>
        ) : (
          history.map(
            ({
              assistant, message_id, user_message, message_input,
            }) => (
              <React.Fragment key={message_id}>
                {user_message ? (
                  <ChatMessage
                    key={`user-${message_id}`}
                    speaker="user"
                    text={user_message}
                  />
                ) : (
                  ''
                )}
                {assistant ? (
                  <ChatMessage
                    key={`assistant-${message_id}`}
                    speaker="assistant"
                    text={assistant}
                    input={message_input}
                  />
                ) : (
                  ''
                )}
              </React.Fragment>
            ),
          )
        )}
      </div>
    </Card>
  );
}

export default ChatMessages;
